import { Checkbox, FormControlLabel, FormGroup, Typography } from '@mui/material';
import React from 'react';
import { Palette } from 'Palette';
import { ALL_SECTOR_OPTIONS } from '../fundOpportunitySectorOptions';
import { FundDetailsFormData } from './fundDetailsFormTypes';

export interface FundSectorCheckboxesProps {
  sector: FundDetailsFormData['sector'];
  onSectorChange: (sectorValue: FundDetailsFormData['sector'][number]) => void;
}

const FundSectorCheckboxes: React.FC<FundSectorCheckboxesProps> = ({ sector, onSectorChange }) => (
  <>
    <Typography component="span" variant="subtitle2" sx={{ display: 'block', mb: 0.5 }}>
      Sectors
    </Typography>
    <FormGroup
      row
      sx={{
        backgroundColor: 'white',
        borderRadius: '4px',
        padding: '8px',
        columnGap: '10px',
      }}
    >
      {ALL_SECTOR_OPTIONS.map((opt) => (
        <FormControlLabel
          key={opt.value}
          control={
            <Checkbox
              checked={sector?.includes(opt.value) || false}
              onChange={() => onSectorChange(opt.value)}
              sx={{
                '&.Mui-checked': {
                  color: Palette.default.buttonBg,
                },
              }}
            />
          }
          label={opt.label}
        />
      ))}
    </FormGroup>
  </>
);

export default FundSectorCheckboxes;
